var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7104_1406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 4.5C22.89 4.5 20.385 5.715 18.75 7.635C17.115 5.715 14.61 4.5 12 4.5C7.38 4.5 3.75 8.13 3.75 12.75C3.75 18.42 8.85 23.04 16.575 30.06L18.75 32.025L20.925 30.045C28.65 23.04 33.75 18.42 33.75 12.75C33.75 8.13 30.12 4.5 25.5 4.5ZM18.9 27.825L18.75 27.975L18.6 27.825C11.46 21.36 6.75 17.085 6.75 12.75C6.75 9.75 9 7.5 12 7.5C14.31 7.5 16.56 8.985 17.355 11.04H20.16C20.94 8.985 23.19 7.5 25.5 7.5C28.5 7.5 30.75 9.75 30.75 12.75C30.75 17.085 26.04 21.36 18.9 27.825Z",
    fill: "#5F6368"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7104_1406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteSvg);
export default __webpack_public_path__ + "static/media/favoriteSvg.a6f1327d150c2b0fe164acadebc5de7c.svg";
export { ForwardRef as ReactComponent };